// RBAC: which modules each role can see.
export const MODULE_ACCESS = {
    dashboard: [
        "super_admin",
        "operations_manager",
        "field_technician",
        "customer_service_agent",
        "sales_manager",
        "sales_rep",
        "it_admin",
        "read_only_viewer",
    ],
    services: ["super_admin", "operations_manager", "it_admin", "sales_manager", "sales_rep"],
    customers: ["super_admin", "operations_manager", "customer_service_agent", "sales_manager", "sales_rep", "it_admin"],
    fieldOps: ["super_admin", "operations_manager", "field_technician"],
    tickets: ["super_admin", "operations_manager", "customer_service_agent", "field_technician", "it_admin"],
    conversations: ["super_admin", "operations_manager", "customer_service_agent", "it_admin"],
    kb: ["super_admin", "operations_manager", "customer_service_agent", "field_technician", "it_admin", "sales_manager", "sales_rep"],
    sales: ["super_admin", "sales_manager", "sales_rep"],
    revenue: ["super_admin", "operations_manager"],
    analytics: [
        "super_admin",
        "operations_manager",
        "sales_manager",
        "customer_service_agent",
        "it_admin",
        "read_only_viewer",
    ],
    integrations: ["super_admin", "it_admin"],
    admin: ["super_admin", "it_admin"],
};

export const canAccess = (moduleKey, role) =>
    !!role && (MODULE_ACCESS[moduleKey] || []).includes(role);

export const ROLE_BADGE_VARIANT = {
    super_admin: "copper",
    operations_manager: "info",
    field_technician: "warning",
    customer_service_agent: "success",
    sales_manager: "info",
    sales_rep: "info",
    it_admin: "warning",
    read_only_viewer: "neutral",
};

export const ORDER_STATUS_VARIANT = {
    draft: "neutral",
    pending_docs: "warning",
    pending_approval: "warning",
    approved: "info",
    in_provisioning: "info",
    active: "success",
    rejected: "error",
    cancelled: "neutral",
};

export const TICKET_STATUS_VARIANT = {
    aberto: "info",
    em_progresso: "warning",
    pendente_cliente: "warning",
    resolvido: "success",
    fechado: "neutral",
};

export const PRIORITY_VARIANT = {
    low: "neutral",
    medium: "info",
    high: "warning",
    critical: "error",
};

export const CUSTOMER_STATUS_VARIANT = {
    prospect: "info",
    active: "success",
    suspended: "warning",
    churned: "error",
};

export const CUSTOMER_TYPE_VARIANT = {
    individual: "info",
    enterprise: "copper",
    government: "warning",
};
